'use client';
import { type ImageProps, blurDataUrl } from '@/src/common-types';
import { Container } from '@/src/components/container';
import { SectionHeading } from '@/src/components/section-heading';
import type { SectionHeadingWithoutStylingProps } from '@/src/components/section-heading/interface';
import { BREAKPOINTS } from '@/src/themes/interface';
import Image from 'next/image';
import { Form } from './form';

export interface ContactSectionProps {
  sectionHeading: SectionHeadingWithoutStylingProps;
  image: Omit<ImageProps, 'width' | 'height'>;
}

export function ContactSection({ sectionHeading, image }: ContactSectionProps) {
  return (
    <section className="section-padding-primary bg-gray-50 dark:bg-accent-900">
      <div className="relative py-[60px]">
        {/* Image area  */}
        <div className="absolute left-0 top-0 z-1 h-full w-full overflow-hidden bg-red-500 md:w-[56%] md:rounded-r-5">
          <Image
            src={image.src}
            alt={image.alt}
            fill
            className="object-cover"
            sizes={`(min-width: ${BREAKPOINTS.md}) 60vw, 100vw`}
            placeholder="blur"
            blurDataURL={blurDataUrl}
          />
        </div>

        <Container>
          <div className="ml-auto md:w-1/2">
            <div className="relative z-[2] rounded-5 border-2 border-gray-200 bg-white p-10 shadow-1 dark:border-zinc-700 dark:bg-accent-700 dark:shadow-accent-800  lg:p-[60px]">
              <div className="mb-30px">
                <SectionHeading {...sectionHeading} />
              </div>
              <Form setIsDialogOpen={() => {}} />
            </div>
          </div>
        </Container>
      </div>
    </section>
  );
}
